import { useQuery } from '@apollo/react-hooks';
import type { SelectOption } from '../../../../components';
import { getOptionsLabel } from '../../../Monitor/components';
import { QUALIFICATION_CHECK_FORM_PAGE_DATA } from './QUALIFICATION_CHECK_FORM_PAGE_DATA.gql';
import type {
  GetQualificationCheck,
  ApplicantBasic,
  ApplicationDisplayData,
  QualificationCheck,
} from './types';
import { formatDateString } from '../../../../utils';

export const useGetQualificationCheck = (
  applicationId: string,
): GetQualificationCheck => {
  const { data, loading, error, refetch } = useQuery(
    QUALIFICATION_CHECK_FORM_PAGE_DATA,
    {
      variables: { applicationIdString: applicationId, applicationId },
      skip: !applicationId,
      fetchPolicy: 'network-only',
    },
  );

  const countryList: SelectOption[] =
    data?.programmeChoiceMetadata?.countryList ?? [];

  let applicantBasic: ApplicantBasic | undefined;
  let application: ApplicationDisplayData | undefined;
  let qualificationCheck: QualificationCheck | undefined;

  if (!loading && !error) {
    const {
      applicationNumber,
      nameInEnglishSurname,
      nameInEnglishGivenName,
      nameInChinese,
      gender,
      dateOfBirth,
      nationalityCountryRegion,
      identityType,
      identityNumber,
      emailAddress,
    } = data.studentParticular ?? {};
    applicantBasic = {
      applicationNumber,
      nameInEnglishSurname,
      nameInEnglishGivenName,
      nameInChinese,
      identityType: identityType.replaceAll('_', ' '),
      identityNumber,
      dateOfBirth: formatDateString(dateOfBirth, false) ?? 'N/A',
      gender,
      nationalityCountryRegion: getOptionsLabel(
        countryList,
        nationalityCountryRegion,
      ),
      emailAddress,
    };

    application = data.application;

    // convert country in academic qualification.
    // TODO country convert hook;
    const { academicQualifications } = (application ??
      {}) as ApplicationDisplayData;
    const newAcademicQualifications = academicQualifications.map(aq => {
      const { country } = aq?.institution ?? {};
      const countryLabel = getOptionsLabel(countryList, country);
      return {
        ...aq,
        institution: { ...aq?.institution, country: countryLabel },
      };
    });
    application = application
      ? {
          ...application,
          academicQualifications: newAcademicQualifications,
        }
      : undefined;

    qualificationCheck = data.qualificationCheck;
  }

  return {
    qualificationCheck,
    application,
    applicantBasic,
    loading,
    error,
    refetch,
  };
};
